'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OuterLink = exports.PseudoLink = exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reduxSimple = require('redux-simple');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./Link.pcss');

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var Link = (_dec = (0, _reduxSimple.connect)(function (state) {
  return {
    routing: {
      type: state.routing.type,
      params: state.routing.params
    }
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(Link, _Component);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Link).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'simulateReactRouter',
    value: function simulateReactRouter(event) {
      var _props = this.props;
      var onClick = _props.onClick;
      var dispatch = _props.dispatch;
      var jalan = _props.jalan;

      var allowTransition = true;

      if (onClick) {
        onClick(event);
      }

      if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
        return;
      }

      if (event.defaultPrevented === true) {
        allowTransition = false;
      }

      event.preventDefault();

      if (allowTransition) {
        dispatch(this.getRoutingAction());
        var params = undefined;
        var type = jalan.type;

        if (jalan.params) {
          params = jalan.params;
        } else {
          params = _lodash2.default.omit(jalan, 'type');
        }
        dispatch({ type: type, params: params });
      }
    }
  }, {
    key: 'getRoutingAction',
    value: function getRoutingAction() {
      var jalan = this.props.jalan;
      var type = jalan.type;

      var params = undefined;
      if (jalan.params) {
        params = jalan.params;
      } else {
        params = _lodash2.default.omit(jalan, 'type');
      }
      return { type: type, params: params };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var to = _props2.to;
      var jalan = _props2.jalan;
      var routing = _props2.routing;


      (0, _invariant2.default)(to || jalan, 'Link requires either `to` or `jalan` prop');

      var classNames = (0, _classnames2.default)(styles.link, this.props.noUnderline && styles.noUnderline, this.props.dotted && styles.dotted, this.props.className);

      var activeClassName = (0, _classnames2.default)(!this.props.ignoreActive && styles.active);

      if (jalan) {
        if (_lodash2.default.isEqual(this.getRoutingAction(), routing)) {
          classNames = (0, _classnames2.default)(classNames, activeClassName);
        }
        return _react2.default.createElement(
          'a',
          { href: '#jalan', className: classNames, onClick: this.simulateReactRouter.bind(this) },
          this.props.children
        );
      }

      return _react2.default.createElement(
        _reactRouter.Link,
        { to: to, onClick: this.props.onClick, className: classNames,
          activeClassName: activeClassName },
        this.props.children
      );
    }
  }]);

  return Link;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.any,
  to: _react.PropTypes.string,
  jalan: _react.PropTypes.shape({
    type: _react.PropTypes.string.isRequired
  }),
  ignoreActive: _react.PropTypes.bool,
  noUnderline: _react.PropTypes.bool,
  dotted: _react.PropTypes.bool,
  onClick: _react.PropTypes.func
}, _temp)) || _class);
exports.default = Link;

var PseudoLink = exports.PseudoLink = function (_Component2) {
  _inherits(PseudoLink, _Component2);

  function PseudoLink() {
    _classCallCheck(this, PseudoLink);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(PseudoLink).apply(this, arguments));
  }

  _createClass(PseudoLink, [{
    key: 'render',
    value: function render() {
      var classNames = (0, _classnames2.default)(styles.link, this.props.danger && styles.danger, this.props.white && styles.white, this.props.noUnderline && styles.noUnderline, this.props.dotted && styles.dotted);
      return _react2.default.createElement(
        'span',
        _extends({}, this.props, { className: classNames }),
        this.props.children
      );
    }
  }]);

  return PseudoLink;
}(_react.Component);

PseudoLink.propTypes = {
  children: _react.PropTypes.any,
  white: _react.PropTypes.bool,
  noUnderline: _react.PropTypes.bool,
  dotted: _react.PropTypes.bool
};

var OuterLink = exports.OuterLink = function (_Component3) {
  _inherits(OuterLink, _Component3);

  function OuterLink() {
    _classCallCheck(this, OuterLink);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(OuterLink).apply(this, arguments));
  }

  _createClass(OuterLink, [{
    key: 'render',
    value: function render() {
      var classNames = (0, _classnames2.default)(styles.link, this.props.white && styles.white, this.props.noUnderline && styles.noUnderline, this.props.dotted && styles.dotted);

      return _react2.default.createElement(
        'a',
        _extends({}, this.props, { className: classNames }),
        this.props.children
      );
    }
  }]);

  return OuterLink;
}(_react.Component);

OuterLink.propTypes = {
  children: _react.PropTypes.any,
  white: _react.PropTypes.bool,
  noUnderline: _react.PropTypes.bool,
  dotted: _react.PropTypes.bool
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/Link.js
// module id = 212
// module chunks = 1